<template>
  <b-row class="m-2">
    <b-col>
      <b-form id="form-search-critera">
        <b-row class="OTsectionHeader">
          <b-col cols="12" md="6">
            <h1>Documents Selection for Crawling Jobs</h1>
            <!--<p>Select documents you want to process</p>-->
          </b-col>
          <b-col class="text-right OTbtnContainer" cols="12" md="6">
            <b-button
              type="button"
              variant=" OTSecondary"
              @click="clearAllFiles()"
              :disabled="this.$store.state.localDocuments.isDisabled === 1"
            >
              Cancel
              <ClearUploadedFile v-model="deleteDocModal" />
            </b-button>
            <b-button
              type="submit"
              variant=" OTPrimary"
              @click="uploadFiles()"
              :disabled="this.$store.state.localDocuments.isDisabled == 1"
            >Save</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <p>Select documents you want to process</p>
          </b-col>
          <b-col cols="6" class="text-right">
            <p>
              100 documents maximum per job
              <br />100 MB maximum size per job
            </p>
          </b-col>
        </b-row>

        <b-row
          class="no-gutters"
          id="dropzone"
          :class="[
            isContainDocument ? 'documentWrappertab' : 'documentWrapper'
          ]"
        >
          <b-col
            cols="12"
            class="text-center dropbox"
            :class="[
              isContainDocument ? 'documentWrappertab' : 'documentWrapper'
            ]"
          >
            <span class="dragTxtcontainer">
              <span class="ot-icon-drag-off"></span>
              <span>
                <input
                  type="file"
                  ref="files"
                  multiple
                  class="input-file"
                  @change="handleFilesUpload()"
                  :disabled="this.$store.state.localDocuments.isDisabled === 1"
                />
                Drop your files here to add them or
                <u>
                  <a href="#">browse</a>
                </u>
              </span>
            </span>
          </b-col>

          <b-col cols="12" v-if="isContainDocument === true" class="OTtableLocalBatch">
            <otif-table
              :rows="uploadedDocuments"
              :columns="columns"
              :globalActions="globalActions"
              :actions="actions"
              :editActions="actions"
              :sortable="true"
            ></otif-table>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import CollectionTable from "@/components/CollectionTable.vue";
import DocumentCheckBox from "@/components/jobEditing/localDocuments/DocumentCheckBox.vue";
import DocumentHeaderCheckBox from "@/components/jobEditing/localDocuments/DocumentHeaderCheckBox.vue";
import DocumentProgressBar from "@/components/jobEditing/localDocuments/DocumentProgressBar.vue";
import HeaderSize from "@/components/jobEditing/localDocuments/HeaderSize.vue";

import { EventBus } from "@mtm-studio/components/src/lib/eventBus.js";
import axios from "axios";
import ClearUploadedFile from "@/components/jobEditing/localDocuments/ClearUploadedFile.vue";
export default {
  props: ["job", "rows"],

  data() {
    return {
      uploadPercentage: 0,
      deleteDocModal: false,
      uploadedDocuments: [],
      actions: [],
      globalActions: [],
      documentSize: 0,
      dragDropdisabled: false,
      columns: [
        {
          name: "checkBox",
          headerComponent: DocumentHeaderCheckBox,
          displayComponent: DocumentCheckBox
        },
        {
          name: "name",
          label: "Name",
          sortable: true
        },
        {
          name: "source",
          label: "Source"
        },
        {
          name: "type",
          label: "Type",
          sortable: true
        },
        {
          name: "size",
          headerComponent: HeaderSize,
          sortable: true
        },
        {
          name: "",
          label: "",
          displayComponent: DocumentProgressBar
        }
      ],
      postfiles: [],
      isContainDocument: false
    };
  },
  methods: {
    async uploadFiles() {
      var baseUrl = "/mtm-gateway-api/v1/services/crawlers-admin";
      var url = baseUrl + "/ldc/";
      var length = this.postfiles.length;
      if (length > 0) {
        this.$store.state.localDocuments.isDisabled = 1;
        this.dragDropdisabled = true;
        this.$snotify.info("Saving Documents", { timeout: 0 });
        this.$store.state.localDocumentProgress.documents = [];
        //ENABLING progress bar making value with 0
        for (var i = 0; i < length; i++) {
          this.setProgress(1, this.postfiles[i].name, i);
          var formData = new FormData();
          formData.append("file", this.postfiles[i]);
          try {
            const res = await axios.post(url + this.job.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: function(progressEvent) {
                this.uploadPercentage = parseInt(
                  Math.round((progressEvent.loaded / progressEvent.total) * 100)
                );
                this.setProgress(
                  this.uploadPercentage,
                  this.postfiles[i].name,
                  i
                );
              }.bind(this)
            });

            if (res.status >= 200 && res.status < 300 && i === length - 1) {
              this.loadServerDocuments();
              this.$snotify.clear();
              this.$snotify.success("Documents are saved.");
              this.$store.state.localDocuments.checkAll = false;
              this.$store.state.localDocuments.documents = [];
              this.$store.state.localDocuments.deletefiles = [];
              this.$store.state.localDocuments.isDisabled = 0;
              this.dragDropdisabled = false;
              this.job.save().then(() => {
                this.$eventBus.$emit("job-saved");
              });
            }
          } catch (err) {
            this.$snotify.clear();
            this.$snotify.error(err.response.data.detail);
            console.error(err);
            this.$store.state.localDocuments.isDisabled = 0;
            this.dragDropdisabled = false;
          }
        }
        this.loadServerDocuments();
      } else {
        this.$snotify.clear();
        this.$snotify.error("No documents detected.");
        this.$store.state.localDocuments.isDisabled = 0;
        this.dragDropdisabled = false;
      }
    },
    handleFilesUpload() {
      var files = this.$refs.files.files;
      var length = files.length;
      for (var i = 0; i < length; i++) {
        this.documentSize += Number.parseFloat(files[i].size / (1024 * 1024));
        if (
          this.uploadedDocuments.length <= 99 &&
          this.documentSize.toFixed(2) <= 100
        ) {
          this.uploadedDocuments.push({
            1: files[i].name,
            2: "Local",
            3: files[i].type,
            4: (files[i].size / (1024 * 1024)).toFixed(2) + " " + "MB",
            size: (files[i].size / (1024 * 1024)).toFixed(2)
          });
          this.postfiles.push(files[i]);
        } else {
          this.uploadedDocuments = [];
          this.postfiles = [];
          this.documentSize = 0;
          this.loadServerDocuments();
          this.$snotify.clear();
          this.$snotify.error("Exceeded the maximum documents or size per job");
        }
      }
      this.isContainDocument = true;
      this.$refs.files.value = "";
    },
    async loadServerDocuments() {
      try {
        var baseUrl = "/mtm-gateway-api/v1/services/crawlers-admin";
        var url = baseUrl + "/ldc/";
        const res = await axios.get(url + this.job.id);

        if (res.status >= 200 && res.status < 300) {
          var data = res.data;
          this.uploadedDocuments = [];
          this.documentSize = 0;
          this.$store.state.localDocuments.documents = [];
          this.$store.state.localDocuments.deletefiles = [];
          for (var i = 0; i < data.length; i++) {
            this.uploadedDocuments.push({
              1: data[i].name,
              2: "Local",
              3: data[i].type,
              4: (data[i].size / (1024 * 1024)).toFixed(2) + " " + "MB",
              size: (data[i].size / (1024 * 1024)).toFixed(2)
            });
            this.documentSize += Number.parseFloat(
              data[i].size / (1024 * 1024)
            );

            const payload = {
              documentId: i,
              documentName: data[i].name,
              checked: false
            };
            this.$store.commit("localDocuments/PUSH_DOCUMENTS", payload);
          }
          if (data.length > 0) {
            this.isContainDocument = true;
            this.postfiles = [];
          } else {
            this.isContainDocument = false;
            this.documentSize = 0;
            this.postfiles = [];
          }
        } else {
          this.$snotify.clear();
          this.$snotify.error("No documents detected.");
        }
      } catch (err) {
        console.error(err);
      }
    },
    async deleteDocument(fileName, rows, rowNumber) {
      var baseUrl = "/mtm-gateway-api/v1/services/crawlers-admin";
      var url =
        baseUrl +
        "/ldc/delete/" +
        this.job.id +
        "?fileName=" +
        encodeURIComponent(fileName);

      try {
        const res = await axios.delete(url);
        if (res.status === 200) {
          this.$store.commit("localDocuments/CHECK_ALL_DOCUMENTS", false);
          this.loadServerDocuments();
          if (rows.length === 0) {
            this.isContainDocument = false;
          } else {
            this.isContainDocument = true;
          }
        } else {
          this.$snotify.clear();
          this.$snotify.error("Error deleting docuemnt");
        }
      } catch (err) {
        console.error(err);
      }
    },
    clearAllFiles() {
      this.$refs.files.value = "";
      if (this.postfiles.length > 0) {
        this.deleteDocModal = true;
      } else {
        this.$snotify.clear();
        this.$snotify.error("No documents detected.");
      }
      this.$store.state.localDocuments.checkAll = false;
      this.$store.state.localDocuments.documents = [];
      this.$store.state.localDocuments.deletefiles = [];
    },
    async deleteCommaSeparatedFile(file) {
      var baseUrl = "/mtm-gateway-api/v1/services/crawlers-admin";
      var url =
        baseUrl +
        "/ldc/delete/" +
        this.job.id +
        "?fileName=" +
        encodeURIComponent(file);
      try {
        const res = axios.delete(url);
        if (res.status !== 200) {
          this.$snotify.clear();
          this.$snotify.error("Error deleting docuemnt");
        }
      } catch (err) {
        console.error(err);
      }
    },
    async deleteAllDocuments(selectedFiles) {
      var deleteFiles = [];
      var baseUrl = "/mtm-gateway-api/v1/services/crawlers-admin";
      selectedFiles.forEach(file => {
        if (file.indexOf(",") !== -1) {
          this.deleteCommaSeparatedFile(file);
        } else {
          deleteFiles.push(file);
        }
      });

      var url =
        baseUrl +
        "/ldc/deleteAll/" +
        this.job.id +
        "?fileNames=" +
        encodeURIComponent(deleteFiles);
      try {
        const res = await axios.delete(url);
        if (res.status === 200) {
          this.$store.commit("localDocuments/CHECK_ALL_DOCUMENTS", false);
          this.loadServerDocuments();
          this.$snotify.clear();
          this.$snotify.success("Selected documents are deleted.");
        } else {
          this.$snotify.clear();
          this.$snotify.error("Error deleting docuemnt");
        }
      } catch (err) {
        console.error(err);
      }
    },
    setProgress(progress, fileName, rownum) {
      var isUploading = true;
      const payload = {
        progress: progress,
        fileName: fileName,
        rowNumber: rownum,
        uploading: isUploading
      };
      this.$store.commit("localDocumentProgress/UPLOAD_PROGRESS", payload);
    }
  },
  mounted() {
    this.loadServerDocuments();
    var self = this;
    var breadcrumbs = [
      {
        name: "jobs",
        meta: { label: "Jobs" }
      },
      {
        name: "job-edit",
        meta: { label: this.job.get("job_name") },
        params: { job_id: this.job.id }
      },
      {
        name: "local-documents",
        meta: { label: "Documents" },
        params: { job_id: this.job.id }
      }
    ];

    this.$store.commit("breadcrumbs", breadcrumbs);

    window.addEventListener("dragenter", function(e) {});

    window.addEventListener("dragleave", function(e) {
      e.preventDefault();
    });
    window.addEventListener("dragover", function(e) {
      e.preventDefault();
    });

    window.addEventListener("drop", function(e) {
      e.preventDefault();

      if (
        self.job.attributes.status === "Running" ||
        self.job.attributes.status === "Waiting"
      ) {
        self.dragDropdisabled = true;
      }
      if (!self.dragDropdisabled) {
        var files = e.dataTransfer.files;
        var length = files.length;
        for (var i = 0; i < length; i++) {
          self.documentSize += Number.parseFloat(files[i].size / (1024 * 1024));
          if (
            self.uploadedDocuments.length <= 99 &&
            self.documentSize.toFixed(2) <= 100
          ) {
            if (files[i].type === "") {
              // do nothing
            } else {
              self.uploadedDocuments.push({
                1: files[i].name,
                2: "Local",
                3: files[i].type,
                4: (files[i].size / (1024 * 1024)).toFixed(2) + " " + "MB",
                size: (files[i].size / (1024 * 1024)).toFixed(2)
              });

              self.postfiles.push(files[i]);
            }
            self.isContainDocument = true;
          } else {
            self.uploadedDocuments = [];
            self.postfiles = [];
            self.documentSize = 0;
            self.isContainDocument = false;
            self.loadServerDocuments();
            self.$snotify.clear();
            self.$snotify.error(
              "Exceeded the maximum documents or size per job"
            );
            break;
          }
        }
      }
    });
    EventBus.$on("deleteDocument", (rowName, rows, rowNumber) => {
      this.deleteDocument(rowName, rows, rowNumber);
    });

    EventBus.$on("loadServerDocuments", () => {
      this.loadServerDocuments();
    });

    EventBus.$on("deleteAllDocuments", selectedFiles => {
      this.deleteAllDocuments(selectedFiles);
    });
  },
  beforeDestroy() {
    if (this.postfiles.length > 0) {
      this.$snotify.info("Erased unsaved  Documents");
    }
  },
  components: {
    CollectionTable,
    DocumentCheckBox,
    DocumentHeaderCheckBox,
    DocumentProgressBar,
    HeaderSize,
    ClearUploadedFile
  }
};
</script>
